import { render } from "./TournamentsList.vue?vue&type=template&id=d4dc157e&scoped=true"
import script from "./TournamentsList.vue?vue&type=script&lang=js"
export * from "./TournamentsList.vue?vue&type=script&lang=js"

import "./TournamentsList.vue?vue&type=style&index=0&id=d4dc157e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4dc157e"]])

export default __exports__